import { render, staticRenderFns } from "./passInfo.vue?vue&type=template&id=0246f65b&"
import script from "./passInfo.vue?vue&type=script&lang=js&"
export * from "./passInfo.vue?vue&type=script&lang=js&"
import style0 from "./passInfo.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports